import React from 'react'

export default function TextFlow() {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.38574 1.78577H14.7857V13.1858H3.38574V1.78577Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.38574 35.1572H14.7857V46.5572H3.38574V35.1572Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M35.2036 1.78577H46.6036V13.1858H35.2036V1.78577Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M39.2598 33.5032L46.6151 40.8587L39.2598 48.2144" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M46.615 40.8483H14.7852" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M35.2049 7.47864H14.7744" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M36.6777 13.2482L14.7793 35.1464" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
